import React from "react";

export const Knockout = ({ isDisabled, cutterName, resultName }) => {
  if (isDisabled) return null;

  return <feComposite in2={cutterName} operator="out" result={resultName} />;
};

export default Knockout;
